export function headingAnimation() {

          gsap 
          .timeline()
          .fromTo(".hero", {opacity: 0}, {duration: 0.3, opacity: 1})
          .fromTo(".heading_text_1", {opacity: 0, color: "black"}, {duration: 1.2, opacity: 1})
          .fromTo(".heading_text_2", {opacity: 0, color: "black"}, {duration: 1.2, opacity: 1})
          .fromTo(".heading_text_3", {opacity: 0, color: "black"}, {duration: 1.2, opacity: 1})
          .fromTo(".heading_text_4", {opacity: 0, color: "#40C0C0"}, {duration: 0.5, opacity: 1})
          .fromTo(".hero .wp-block-buttons", {opacity: 0}, {duration: 0.5, opacity: 1, delay: 0.1})
          .fromTo(".home .marquee-container", {opacity: 0}, {duration: 0.5, opacity: 1, delay: 0.1});
        
}